module.exports = __webpack_public_path__ + "img/frame (82).353da631.jpg";